/** Tipp-Karte (Fenster, Vorhang, Luftfeuchte) und kleine Wetter-Karte für „Heute“. */
import { Link } from 'react-router';
import { weatherCodeLabel, type Advice } from '@pflanzen/shared';
import type { WeatherView } from '../lib/weather';
import { cx } from './kit';

const LEVEL_STYLE: Record<Advice['level'], string> = {
  alert: 'bg-alert-soft border-alert/30',
  warn: 'bg-sun-soft border-sun/40',
  tip: 'bg-water-soft border-water/25',
  info: 'bg-card border-line',
  good: 'bg-moss-soft border-moss/20',
};

export function AdviceCard({ advice }: { advice: Advice }) {
  return (
    <div className={cx('rise flex gap-3 rounded-3xl border p-3.5', LEVEL_STYLE[advice.level])}>
      <div className="text-2xl leading-none">{advice.icon}</div>
      <div className="min-w-0">
        <div className="text-[15px] font-semibold">{advice.title}</div>
        <div className="mt-0.5 text-sm text-ink/75">{advice.detail}</div>
      </div>
    </div>
  );
}

export function WeatherMini({ view }: { view: WeatherView | null }) {
  if (!view) {
    return <div className="h-[74px] animate-pulse rounded-3xl bg-card" />;
  }
  const { weather, climate } = view;
  const cond = condition(weather.now.code, weather.now.isDay);
  return (
    <Link to="/wetter" className="flex items-center gap-3 rounded-3xl border border-line bg-card p-3.5 active:scale-[0.99]">
      <div className="text-3xl leading-none">{cond.icon}</div>
      <div className="min-w-0 flex-1">
        <div className="text-[15px] font-semibold">
          {Math.round(weather.now.temp)}° · {cond.label} <span className="font-normal text-muted">· {weather.location.name}</span>
        </div>
        <div className="text-sm text-muted">
          Drinnen ca. {climate.indoorRh} % Luftfeuchte
        </div>
      </div>
      <div className="text-sm font-semibold text-moss">Wetter ›</div>
    </Link>
  );
}

/** Wetter-Symbol; nachts Mond statt Sonne. */
export function condition(code: number, isDay: boolean): { label: string; icon: string } {
  const c = weatherCodeLabel(code);
  if (isDay) return c;
  if (code <= 1) return { label: c.label, icon: '🌙' };
  if (code === 2) return { label: c.label, icon: '☁️' };
  // Schauer/Niesel: Symbol ohne Sonne
  if (c.icon === '🌦️') return { label: c.label, icon: '🌧️' };
  return c;
}
